import React from "react";
import { useField } from "formik";
import { FormControlLabel, Switch } from "@mui/material";
import { useFormikContext } from "formik";

function SwitchField(props: any) {
  const {defaultChecked, label,name, ...rest } = props;
  const [field] = useField(props);
  const { setFieldValue } = useFormikContext();

  const handleChange = () => {
    setFieldValue(field.name, !field.value);
  };

  return (
    <FormControlLabel
      control={<Switch color="secondary" {...field} onChange={() => handleChange()} checked={field.value} value={field.value} />}
      labelPlacement="end"
      label={label}
      {...rest}
      defaultChecked={defaultChecked}
    />
  );
}

export default SwitchField;
